import { Async, toAsyncFetched } from '@client/new/helpers/types';
import { Exact, GetWorkoutByIdQuery, Scalars } from 'generated/graphql';
import { useAsyncQuery } from '@client/new/helpers/gql';
import { QueryResult } from '@apollo/client';
import { toExerciseDTOs } from './workout.mappers';
import { ExerciseDTO } from './workout.domain';

export type WorkoutModel = {
  exercises: ExerciseDTO[];
};

type WorkoutModelParams = {
  data: QueryResult<GetWorkoutByIdQuery, Exact<{ id: Scalars['Int'] }>>;
};

export const useWorkoutModel = (p: {
  data: WorkoutModelParams['data'];
}): Async<WorkoutModel> => {
  const res = useAsyncQuery(p.data, 'workout', toExerciseDTOs, [])['data'];
  if (res.type !== 'fetched') return res;
  return toAsyncFetched({ exercises: res.value });
};
